import { render, staticRenderFns } from "./program-list.vue?vue&type=template&id=5b3d41dc&scoped=true&"
import script from "./program-list.vue?vue&type=script&lang=js&"
export * from "./program-list.vue?vue&type=script&lang=js&"
import style0 from "./program-list.vue?vue&type=style&index=0&id=5b3d41dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d41dc",
  null
  
)

export default component.exports